import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import useAppStore from "../Store/SearchStore.jsx";
import { tagClickAPI } from "../Services/giftService.js";
import { useTranslation } from "react-i18next";

/**
 * Custom hook for product actions (redirect, tag clicks, etc.)
 * @param {string} productId - Product ID
 * @param {string} url - Product URL
 * @param {Function} onProductClick - Optional callback for product click
 * @returns {Object} Action handlers
 */
export const useProductActions = (productId, url, onProductClick) => {
    const history = useHistory();
    const { setTag, demoifySearchText } = useAppStore();
    const { i18n } = useTranslation();

    /**
     * Handle product redirect and track click
     */
    const handleRedirect = useCallback(() => {
        window.open(url, "_blank");
        onProductClick?.();
    }, [url, onProductClick]);

    /**
     * Handle tag click - fetch related sentences and update search
     * @param {string} tagId - Tag ID
     * @param {string} tag - Tag text
     */
    const handleTagClick = useCallback(
        async (tagId, tag) => {
            try {
                const response = await tagClickAPI(
                    productId,
                    tag,
                    localStorage.getItem("prompt"),
                    i18n.language
                );

                if (response?.generatedSentences) {
                    setTag(response.generatedSentences);
                    console.log(response.generatedSentences);
                }
            } catch (error) {
                console.error("Error handling tag click:", error);
            }
        },
        [productId, setTag, i18n.language]
    );

    /**
     * Handle search redirect with encoded query
     * @param {string} prompt - Search prompt
     */
    const handleSearchRedirect = useCallback(
        (prompt) => {
            console.log(prompt);
            const demodifiedText = demoifySearchText(prompt);
            const encodedSearchText = btoa(demodifiedText);
            history.push(`/search?query=${encodedSearchText}`);
        },
        [history, demoifySearchText]
    );

    return {
        handleRedirect,
        handleTagClick,
        handleSearchRedirect,
    };
};
